<template>
  <div class="dialog" @click="jump">
    <div class="dialog-board">
      <div class="dialog-bottom"></div>
      <div class="dialog-text">{{ data.word }}</div>
      <div class="dialog-person">
        <img
          :src="'//cdn.original-fun.com/gugong/' + data.headImg + '.png'"
        />
      </div>
    </div>
  </div>
</template>

<script>
//script
import Tools from '../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../scripts/Global';

export default {
  props: ['data'],
  data() {
    return {};
  },
  components: {},
  created() {
    Global.pauseAll();
    Global.audioIntorPauseAll();
    if (this.data.audio) {
      Global.startPlay(this.data.audio, this.data.scene);
    }
  },
  computed: {},
  methods: {
    jump() {
      this.$emit('jump');
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dialog {
  width: 100%;
  height: 5rem;
  position: absolute;
  bottom: 0;
  .dialog-board {
    width: 100%;
    height: 4.15rem;
    background: rgba(255, 255, 255, 0.2)
      url(./../../assets/common/dialog-board.png) no-repeat center bottom;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .dialog-bottom {
    width: 7.5rem;
    height: 1.69rem;
    background-image: url(./../../assets/common/dialog-bottom.png);
    @include singleBg;
    position: absolute;
    left: 0;
    bottom: 0.5rem;
  }
  .dialog-text {
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.05rem;
      width: 0.4rem;
      height: 0.34rem;
      background-image: url(./../../assets/common/dialog-tz.png);
      @include singleBg;
    }
    text-indent: 0.5rem;
    position: absolute;
    color: #775b4b;
    width: 3.7rem;
    left: 0.5rem;
    top: 0.4rem;
    text-align: justify;
    font-size: 0.28rem;
    font-weight: bold;
    z-index: 3;
  }
  .dialog-person {
    width: 3.2rem;
    position: absolute;
    right: 0.2rem;
    z-index: 2;
    bottom: 1rem;
    img {
      width: 100%;
    }
  }
}
</style>
